import { TransactionOriginatorTypeGroup } from '@features/transactions/enums/transactionOriginatorTypeGroup'
import { TransactionSortProperty } from '@features/transactions/enums/transactionSortProperty'

import { SortDirection } from '../../../enums/sortDirection'
import type { TransactionsListFilters } from '../contexts/transactionsListFiltersContext'

export const defaultTransactionsQuery: TransactionsListFilters = {
  journalCode: undefined,
  originatorType: undefined,
  originatorTypeGroup: Object.values(TransactionOriginatorTypeGroup),
  page: 1,
  pageSize: undefined,
  period: undefined,
  searchQuery: undefined,
  sortDirection: SortDirection.Desc,
  sortProperty: TransactionSortProperty.TransactionNo,
  withVoided: undefined,
  withHasVoucher: true,
}
